import React from "react";

import pdfIcon from "../../../assets/images/pdfIcon.svg";
import bmpIcon from "../../../assets/images/bmpIcon.svg";
import dotIcon from "../../../assets/images/dotIcon.svg";
import excelIcon from "../../../assets/images/excelIcon.svg";
import jpegIcon from "../../../assets/images/jpegIcon.svg";
import jpgIcon from "../../../assets/images/jpgIcon.svg";
import odsIcon from "../../../assets/images/odsIcon.svg";
import pngIcon from "../../../assets/images/pngIcon.svg";
import tiffIcon from "../../../assets/images/tiffIcon.svg";
import txtIcon from "../../../assets/images/txtIcon.svg";
import wordIcon from "../../../assets/images/wordIcon.svg";
import xmlIcon from "../../../assets/images/xmlIcon.svg";
import unsupportedIcon from "../../../assets/images/unsupportedIcon.svg";
import { RiFileVideoFill } from "react-icons/ri";

import { Image, Flex } from "@chakra-ui/react";

const ExtensionIcon = ({ path }) => {
  const handleIcon = () => {
    path = path?.toLowerCase();

    if (path?.includes(".pdf")) {
      return pdfIcon;
    } else if (path?.includes(".doc") || path?.includes(".docx")) {
      return wordIcon;
    } else if (path?.includes(".xls") || path?.includes(".xlsx")) {
      return excelIcon;
    } else if (path?.includes(".jpg")) {
      return jpgIcon;
    } else if (path?.includes(".png")) {
      return pngIcon;
    } else if (path?.includes(".jpeg")) {
      return jpegIcon;
    } else if (path?.includes(".txt")) {
      return txtIcon;
    } else if (path?.includes(".xml")) {
      return xmlIcon;
    } else if (path?.includes(".bmp")) {
      return bmpIcon;
    } else if (path?.includes(".dot")) {
      return dotIcon;
    } else if (path?.includes(".ods")) {
      return odsIcon;
    } else if (path?.includes(".tiff")) {
      return tiffIcon;
    } else if (path?.includes(".webm")) {
      return (
        <Flex alignItems="center">
          <RiFileVideoFill size={24} />
        </Flex>
      );
    } else {
      return unsupportedIcon;
    }
  };
  const icon = handleIcon();

  return (
    <>
      {typeof icon === "string" ? (
        <Image src={icon} h="100%" w="100%" alt="file-icon" />
      ) : typeof icon === "function" ? (
        React.createElement(icon, { height: "100%", width: "100%" })
      ) : (
        icon
      )}
    </>
  );
};

export default ExtensionIcon;
